module.exports = __webpack_public_path__ + "static/media/password_icon.933c7fa5.svg";